import { Some, None } from "@siteimprove/alfa-option";
import { Refinement } from "@siteimprove/alfa-refinement";
const { isFunction, isObject } = Refinement;
/**
 * @public
 */
export var Serializable;
(function (Serializable) {
    function isSerializable(value) {
        return isObject(value) && isFunction(value.toEARL);
    }
    Serializable.isSerializable = isSerializable;
    function toEARL(value) {
        if (isSerializable(value)) {
            return Some.of(value.toEARL());
        }
        return None;
    }
    Serializable.toEARL = toEARL;
})(Serializable || (Serializable = {}));
//# sourceMappingURL=serializable.js.map